
import { parse, isValid } from 'date-fns';

const tryParseDate = (dateStr: string) => {
  const formats = ["yyyy-MM-dd", "dd-MM-yyyy", "dd/MM/yyyy", "dd MMM yyyy", "yyyy/MM/dd", "dd.MM.yyyy"];

  for (let format of formats) {
    const parsedDate = parse(dateStr, format, new Date());
    if (isValid(parsedDate)) {
      return parsedDate;
    }
  }
  return null;
};
export default tryParseDate